module.exports = __webpack_public_path__ + "img/greg_rhj61g.3ba2ae6f.png";